// src/components/messenger/MessageInputBar.tsx
import React, { useState, useRef, useLayoutEffect } from 'react';
import { styled } from '../../styles/stitches.config';
import { PlusCircleFill, EmojiSmile, SendFill } from 'react-bootstrap-icons';
import { InputBarWrapper, MessageInputContainer, MessageTextarea, SendIcon, StyledIconButton } from '../../styles/messenger/messenger.style';

// --- STYLED COMPONENTS ---



// --- REACT COMPONENT ---

interface MessageInputBarProps {
  onSendMessage: (message: string) => void;
}

export const MessageInputBar: React.FC<MessageInputBarProps> = ({ onSendMessage }) => {
  const [text, setText] = useState('');
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  // Auto-resize the textarea based on content
  useLayoutEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto'; // Reset height
      textarea.style.height = `${textarea.scrollHeight}px`; // Set to scroll height
    }
  }, [text]);

  const handleSend = () => {
    if (text.trim()) {
      onSendMessage(text.trim());
      setText('');
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    // Send on Enter, but allow new line with Shift+Enter
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault(); // Prevent new line
      handleSend();
    }
  };

  return (
    <InputBarWrapper>
      <MessageInputContainer>
        <MessageTextarea
          ref={textareaRef}
          rows={1}
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Type a message..."
        />
        {/* <StyledIconButton style={{ marginLeft: '0.5rem' }}><EmojiSmile size={20} /></StyledIconButton> */}
      </MessageInputContainer>
      <StyledIconButton onClick={handleSend}><SendIcon size={22}/></StyledIconButton>
    </InputBarWrapper>
  );
};